import { SkeletonBox } from '@circlefin/components'

import { CopyItem } from '../CopyItem/CopyItem'

export type GridItem = {
  label: string
  id: string
  value: string | undefined | null
}

export interface CopyGridProps {
  /**
   * Grid Items to display.
   */
  gridItems: GridItem[]
  /**
   * Controls skeleton loading state.
   */
  loading?: boolean
}

export const CopyGrid: React.FC<CopyGridProps> = ({
  loading = false,
  gridItems,
}) => {
  return gridItems.map(({ label, value, id }) => (
    <SkeletonBox key={id} className="block h-10" loading={loading}>
      {value && <CopyItem id={id} label={label} value={value} />}
    </SkeletonBox>
  ))
}
